<template>
  <div
    v-for="device in deviceList"
    :key="device.deviceid"
  >
    <MonitorDevice
      :setdevice="device"
      :devicedata="deviceDataMap[device.deviceid]"
      @client-device-updated="handleDeviceUpdated"
      @config-updated="handleConfigUpdated"
    />
  </div>
</template>

<script setup lang="ts">

import type { Client, Device, DeviceData } from '@/types/commontypes'
import { onMounted,  watch, ref } from 'vue';
import MonitorDevice from '../components/MonitorDevice.vue'

const props = defineProps<{
    setclient: Client;
    setdevice: Device;
}>();

const deviceList = ref<Device[]>([])
const deviceDataMap = ref<Record<string, DeviceData>>({});          // 디바이스별 데이터 리스트

onMounted(async () =>{
    initDeivceInfo();
});


watch(
  () => props.setclient,
  (_newVal, _oldVal) => {
  },
  { deep: true}
);

function reloadData() {
    initDeivceInfo();
}

/**
 *  선택된 client 와 디바이스의 선택된 상태에 따라 디바이스 리스트를 불러옴
 * 
*/
function initDeivceInfo() {
    const getDeivce = props.setdevice;
    if(getDeivce.devicename === 'ALL' || getDeivce.devicename === '') {
        // 전체 디바이스 처리
        LoadDeviceList();
    } else {
        // 선택된 디바이스 만 처리
        deviceList.value = [];
        deviceList.value.push(props.setdevice);
    }
}

function LoadDeviceList() {
	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "getDevicelist", 'clientcode' : props.setclient.clientcode});
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Device[] = JSON.parse(xhr.responseText);
		const sortResult = result.sort((a, b) => a.devicename.localeCompare(b.devicename));

        deviceList.value = [];

		for(let device of sortResult) {
			deviceList.value.push(device);
		}
        // console.log("loaddevice list ", deviceList.value)

        LoadDeviceListLastata();
	});
}

function ReloadDeviceList() {
	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "getDevicelist", 'clientcode' : props.setclient.clientcode});
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Device[] = JSON.parse(xhr.responseText);
		const sortResult = result.sort((a, b) => a.devicename.localeCompare(b.devicename));

        deviceList.value = [];

		for(let device of sortResult) {
			deviceList.value.push(device);
		}
        
        // LoadDeviceListLastata();
	});
}

function LoadDeviceListLastata(deviceid?: string) {
    let idlist = [];
    
    const devObjList = deviceList.value;
    if(!deviceid) {
        idlist = devObjList.map((item) => `"${item.deviceid}"`)
    } else {
        idlist = devObjList
            .filter((item) => item.deviceid == deviceid)
            .map((item) => `"${item.deviceid}"`)
    }
    // console.log("load last data idlist : ", idlist)
    if(!idlist || idlist.length <= 0)
        return;

    // 측정기의 마지막 들어온 값을 요청함
    const data  = JSON.stringify({ 'operator': "getDeivceListLastRow", 'devicelist': idlist});
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function() {
		const result = xhr.responseText;
        if(!result)
            return;

		const retlist:DeviceData[] = JSON.parse(result);
        console.log("read devcie last data : ", retlist)

        // 기존 데이터를 유지하면서 새 데이터만 병합
        retlist.forEach(deviceData => {
            deviceDataMap.value[deviceData.deviceid] = deviceData;
        });
 	});
}

function handleDeviceUpdated(_deviceid: string) {
    ReloadDeviceList()
}

function handleConfigUpdated(data: { deviceid: string, config: string, alertconfig: string }) {
    console.log("MonitorClient handleConfigUpdated : ", data)
    // deviceList에서 해당 device를 찾아서 config 업데이트
    const device = deviceList.value.find(d => d.deviceid === data.deviceid)
    if (device) {
        device.config = data.config
        device.alertconfig = data.alertconfig
    }
}

defineExpose({ reloadData })   // 부모에서 이 메서드 호출 가능하게 공개

</script>
<style lang="">
    
</style>